import { Inject, Injectable } from '@angular/core';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { Batch } from '../../interfaces/batches/batch';
import { BatchForUpdate } from '../../interfaces/batches/batch-for-update';
import { BatchForCreation } from '../../interfaces/batches/batch-for-creation';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { eBatchType } from '../../enums';

@Injectable({
    providedIn: 'root'
})
export class BatchRepositoryService extends PaginatedRepository<Batch> {
    protected override _baseLink: string;

    constructor(
        http: HttpClient,
        messageService: ToastrService,
        @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
        super(http, messageService);

        this._baseLinkTemplate = `${config.batchRootURL}/Bundles/[0]/Batches`;
        this._baseLink = `${config.batchRootURL}/Batches`;
    }

    private generateHeaders = () => {
        return {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        }
    }

    public getBatchSample = (batchTypeID: eBatchType) => {
        return this.http.get<Blob>(
            `${this.config.batchRootURL}/Batches/Sample/${batchTypeID}`, {
                responseType: 'blob' as 'json'
            });
    }

    public getBatchReadme = (batchTypeID: eBatchType) => {
        return this.http.get(
            `${this.config.batchRootURL}/Batches/Readme/${batchTypeID}`, {
                responseType: 'blob'
            });
    }

    public getBatch = (bundleID: string, batchID: string) => {
        return this.http.get<Batch>(
            `${this.config.batchRootURL}/Bundles/${bundleID}/Batches/${batchID}`, 
            this.generateHeaders());
    }

    public createBatch = (bundleID: string, batch: BatchForCreation) => {
        return this.http.post<Batch>(`${this.config.batchRootURL}/Bundles/${bundleID}/Batches`, 
            batch,
            this.generateHeaders());
    }

    public updateBatch = (bundleID: string, batchID: string, batch: BatchForUpdate) => {
        return this.http.put<Batch>(
            `${this.config.batchRootURL}/Bundles/${bundleID}/Batches/${batchID}`, 
            batch, 
            this.generateHeaders());
    }

    public deleteBatch = (bundleID: string, batchID: string) => {
        return this.http.delete<Batch>(
            `${this.config.batchRootURL}/Bundles/${bundleID}/Batches/${batchID}`, 
            this.generateHeaders());
    }
}